import { Avatar, SwipeableDrawer, Typography } from '@mui/material'
import React, { memo, useEffect, useState } from 'react'
import Menu from '../sideNav/menu'
import { menuData } from '../sideNav/navItems'
import Logo from '../../../assets/images/Girlush Logo.png'
import axios from 'axios'

const MenuDrawer = ({open , onClose}) => {
  const [flag,setFlag] = useState(true)
  const role_id = localStorage.getItem('role_id')
  const [data,setData] = useState([])

  function getSideData(){
    axios.get(`v1/menuauth/list/1/${role_id}`)
    .then(res=>{
     setData(res.data)
    })
    .catch(err=>{
      console.log(err.response)
    })
  }
  useEffect(() => {
    getSideData()
  },[])
  return (
   <SwipeableDrawer
   anchor='left'
   open={open}
   onOpen={()=>onClose(true)}
   onClose={()=>onClose(false)}
   sx={{zIndex:1300,}}
   >
<div style={{height:'100%', width:270,}}>
<div className='flex items-center justify-center m-2'>
  <Avatar src={Logo}/>
  <Typography variant="h5" ml={2}>GIRLUSH</Typography>
</div>
<Menu data={data} flag={flag} setFlag={setFlag}/>
</div>
   </SwipeableDrawer>
  )
}

export default memo(MenuDrawer)